import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BridgerParamsState {
  params: any; // Define a more specific type if possible
  disableRequisition: boolean
}

const initialState: BridgerParamsState = {
  params: null,
  disableRequisition: false
};

const bridgerSliceParam = createSlice({
  name: 'bridgerPlanParams',
  initialState,
  reducers: {
    setBridgerParams(state, action: PayloadAction<any>) {
        // Defensive updates:
        // - If an explicit request/saveParams/params is provided, update state.params
        // - Otherwise preserve existing state.params (so freeze-only updates can't wipe params)
        const payload = action.payload || {};
        if (payload.request) {
          state.params = payload.request;
        } else if (payload.saveParams) {
          state.params = payload.saveParams;
        } else if (payload.params) {
          // some callers may send params directly
          state.params = payload.params;
        } else if (payload.updatedPayload) {
          // legacy callers sometimes wrap params in `updatedPayload`
          state.params = payload.updatedPayload;
        } else if (payload.updatedpayload) {
          state.params = payload.updatedpayload;
        } else {
          // Heuristic: if payload looks like a params object (has one of these keys), accept it
          const possibleParamKeys = ['deliverydate', 'sitecode',  'daypartcode', 'userid'];
          const hasParamKey = Object.keys(payload || {}).some(k => possibleParamKeys.includes(k));
          if (hasParamKey) {
            state.params = payload;
          }
        }

     
    },
  },
});

export const { setBridgerParams } = bridgerSliceParam.actions;

export default bridgerSliceParam.reducer;
